import { Skeleton } from "@/components/ui/skeleton";
import { SPACING, SKELETONS } from "@/design-system";
import { cn } from "@/lib/utils";

interface NotificationCardSkeletonProps {
  className?: string;
}

export function NotificationCardSkeleton({ className }: NotificationCardSkeletonProps) {
  return (
    <div className={cn("flex gap-3 p-4 border-b", className)}>
      <Skeleton className={SKELETONS.elements.avatar.default} />
      <div className={cn('flex flex-col', SPACING.listItemGap, 'flex-1')}>
        <Skeleton className={SKELETONS.elements.content.lineShort} />
        <Skeleton className={SKELETONS.elements.content.line} />
        <Skeleton className={SKELETONS.elements.paragraph.short} />
      </div>
    </div>
  );
}
